// extracted by mini-css-extract-plugin
module.exports = {"balanceSpan":"posDashboard_balanceSpan__2ucKg","balanceDisclaimer":"posDashboard_balanceDisclaimer__UFMHl"};